<template>
  <div>
    <a-table rowKey="id" :columns="columns" :data-source="items" size="small" :pagination="pagination" @change="tableChange" :loading="loading">
      <div slot="avg_retail_price" slot-scope="value">{{ NP.round(value, 2) }}</div>
    </a-table>
  </div>
</template>

<script>
  import NP from 'number-precision'

  export default {
    name: 'UserPane',
    props: ['items', 'loading', 'pagination'],
    data() {
      return {
        NP,
        columns: [
          {
            title: '客户编号',
            dataIndex: 'client_number',
            key: 'client_number',
          },
          {
            title: '客户名称',
            dataIndex: 'client_name',
            key: 'client_name',
          },
          {
            title: '最大值',
            dataIndex: 'max_sales_price',
            key: 'max_sales_price',
          },
          {
            title: '最小值',
            dataIndex: 'min_sales_price',
            key: 'min_sales_price',
          },
          {
            title: '平均值',
            dataIndex: 'avg_sales_price',
            key: 'avg_sales_price',
          },
          {
            title: '总数量',
            dataIndex: 'total_sales_quantity',
            key: 'total_sales_quantity',
          },
          {
            title: '销售总金额',
            dataIndex: 'total_sales_amount',
            key: 'total_sales_amount',
          }
        ],
      };
    },
    methods: {
      tableChange(pagination, filters, sorter) {
        this.$emit('tableChange', pagination, filters, sorter)
      },
    }
  }
</script>
